import { render, staticRenderFns } from "./CorporateAnnouncementMezzanine.vue?vue&type=template&id=64efee82&scoped=true"
import script from "./CorporateAnnouncementMezzanine.vue?vue&type=script&lang=js"
export * from "./CorporateAnnouncementMezzanine.vue?vue&type=script&lang=js"
import style0 from "./CorporateAnnouncementMezzanine.vue?vue&type=style&index=0&id=64efee82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64efee82",
  null
  
)

export default component.exports